const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Help24 = function Help24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M12 1a10.994 10.994 0 1 0 .012 0H12zm0 17a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm3.33-7.65a4.583 4.583 0 0 1-1.28 1.95 2.6 2.6 0 0 0-.91 1.44 1 1 0 0 1-.99.89c-.04 0-.07-.01-.11-.01a1 1 0 0 1-.88-1.107 4.355 4.355 0 0 1 1.45-2.59c.347-.305.62-.684.8-1.11a1.364 1.364 0 0 0-.22-1.41 1.72 1.72 0 0 0-1.61-.33 1.533 1.533 0 0 0-1.11 1.16 1 1 0 1 1-1.94-.46 3.488 3.488 0 0 1 2.51-2.62 3.64 3.64 0 0 1 3.56.84 3.26 3.26 0 0 1 .73 3.357z",
      fill: "currentColor",
    })
  );
};
Help24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Help16 = function Help16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.86-6.47a3.7 3.7 0 0 1-1.1 1.58c-.45.45-.73.74-.78 1.17a.845.845 0 0 1-.95.71.81.81 0 0 1-.752-.864V9.1A3.5 3.5 0 0 1 8.52 6.99c.297-.242.534-.55.69-.9a1.058 1.058 0 0 0-.19-1.14 1.542 1.542 0 0 0-1.38-.27 1.247 1.247 0 0 0-.95.94.849.849 0 0 1-1.03.6.808.808 0 0 1-.646-.943l.006-.027a2.925 2.925 0 0 1 2.16-2.13 3.26 3.26 0 0 1 3.05.68 2.568 2.568 0 0 1 .63 2.73z",
      fill: "currentColor",
    })
  );
};
Help16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Help24,
  16: Help16,
};
export function Help(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Help' icon. Please use one of the available sizes: '16', '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
